import { render, staticRenderFns } from "./FullWidthText.vue?vue&type=template&id=019b0c52&scoped=true&"
import script from "./FullWidthText.vue?vue&type=script&lang=js&"
export * from "./FullWidthText.vue?vue&type=script&lang=js&"
import style0 from "./FullWidthText.vue?vue&type=style&index=0&id=019b0c52&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019b0c52",
  null
  
)

export default component.exports